<template>
  <div class="documents-page-wrapper">
    <div class="documents-scroll">
      <div class="documents-data">
        <div class="documents-heading">
          <span>
            {{ $t('message.documentsPage.heading.category') }}
          </span>
          <span>
            
          </span>
        </div>

        <div class="documents-container" v-for="(section, sectionIndex) in documentsList" :key="sectionIndex">
          <div class="document-item-title" @click="toggleSection(sectionIndex)">
            <img src="/custom/images/arrow-up.svg" class="item-arrow" :class="{ 'item-arrow-open': openSections[sectionIndex] }" alt="Arrow">
            <div class="item-link">
              <img src="/custom/images/document.svg" alt="Document">
              <span class="item-desc">
                {{ $t(`message.documentsPage.active.${section.name}`) }}
              </span>
            </div>
          </div>

          <div class="documents-items" :class="{ 'documents-items-open': openSections[sectionIndex] }">
            <div class="documents-heading pl-20">
              <div class="heading-items-block">
                <img src="/custom/images/collapse-open.svg" alt="Collapse">
                <span>
                  {{ $t('message.documentsPage.heading.type') }}
                </span>
              </div>
              <span>
                {{ $t('message.documentsPage.heading.dateEnd') }}
              </span>
            </div>
            <div class="document-item" v-for="(item, index) in section.items" :key="`${sectionIndex}-${index}`">
              <a :href="item.path" class="item-link" :download="`${$t(`message.documentsPage.active.${item.name}`)} ${item.path.split('/').pop()}`">
                <img src="/custom/images/document.svg" alt="Document">
                <span class="item-desc">
                  {{ $t(`message.documentsPage.active.${item.name}`) + ` (ред. до ${item.date})` }}
                </span>
              </a>

              <span class="item-date">
                {{ item.date }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentsArchive',
  data() {
    return {
      openSections: {},
      documentsList: [
        {
          name: 'rules',
          items: [
            {
              path: '/static/documents/archive/rules/14_06_2026.pdf',
              name: 'rules',
              date: '14.06.2026'
            },
            {
              path: '/static/documents/archive/rules/22_04_2026.pdf',
              name: 'rules',
              date: '22.04.2026'
            },
            {
              path: '/static/documents/archive/rules/28_02_2026.pdf',
              name: 'rules',
              date: '28.02.2026'
            },
            {
              path: '/static/documents/archive/rules/12_11_2025.pdf',
              name: 'rules',
              date: '12.11.2025'
            },
            {
              path: '/static/documents/archive/rules/07_10_2025.pdf',
              name: 'rules',
              date: '07.10.2025'
            },
            {
              path: '/static/documents/archive/rules/31_07_2025.pdf',
              name: 'rules',
              date: '31.07.2025'
            },
            {
              path: '/static/documents/archive/rules/29_01_2025.pdf',
              name: 'rules',
              date: '29.01.2025'
            },
            {
              path: '/static/documents/archive/rules/03_12_2024.pdf',
              name: 'rules',
              date: '03.12.2024'
            },
            {
              path: '/static/documents/archive/rules/31_10_2024.pdf',
              name: 'rules',
              date: '31.10.2024'
            },
            {
              path: '/static/documents/archive/rules/08_08_2024.pdf',
              name: 'rules',
              date: '08.08.2024'
            },
            {
              path: '/static/documents/archive/rules/23_05_2024.pdf',
              name: 'rules',
              date: '23.05.2024'
            },
            {
              path: '/static/documents/archive/rules/07_04_2024.pdf',
              name: 'rules',
              date: '07.04.2024'
            },
            {
              path: '/static/documents/archive/rules/05_03_2024.pdf',
              name: 'rules',
              date: '05.03.2024'
            },
            {
              path: '/static/documents/archive/rules/07_11_2023.pdf',
              name: 'rules',
              date: '07.11.2023'
            }
          ]
        },
        {
          name: 'service',
          items: [
            {
              path: '/static/documents/archive/service/11_08_2026.pdf',
              name: 'service',
              date: '11.08.2026'
            },
            {
              path: '/static/documents/archive/service/14_06_2026.pdf',
              name: 'service',
              date: '14.06.2026'
            },
            {
              path: '/static/documents/archive/service/28_02_2026.pdf',
              name: 'service',
              date: '28.02.2026'
            },
            {
              path: '/static/documents/archive/service/12_11_2025.pdf',
              name: 'service',
              date: '12.11.2025'
            },
            {
              path: '/static/documents/archive/service/07_10_2025.pdf',
              name: 'service',
              date: '07.10.2025'
            },
            {
              path: '/static/documents/archive/service/03_12_2024.pdf',
              name: 'service',
              date: '03.12.2024'
            },
            {
              path: '/static/documents/archive/service/31_10_2024.pdf',
              name: 'service',
              date: '31.10.2024'
            },
            {
              path: '/static/documents/archive/service/08_08_2024.pdf',
              name: 'service',
              date: '08.08.2024'
            },
            {
              path: '/static/documents/archive/service/23_05_2024.pdf',
              name: 'service',
              date: '23.05.2024'
            },
            {
              path: '/static/documents/archive/service/07_04_2024.pdf',
              name: 'service',
              date: '07.04.2024'
            },
            {
              path: '/static/documents/archive/service/05_03_2024.pdf',
              name: 'service',
              date: '05.03.2024'
            }
          ]
        },
        {
          name: 'loan',
          items: [
            {
              path: '/static/documents/archive/loan/14_06_2026.pdf',
              name: 'loan',
              date: '14.06.2026'
            },
            {
              path: '/static/documents/archive/loan/22_04_2026.pdf',
              name: 'loan',
              date: '22.04.2026'
            },
            {
              path: '/static/documents/archive/loan/22_07_2025.pdf',
              name: 'loan',
              date: '22.07.2025'
            },
            {
              path: '/static/documents/archive/loan/12_06_2025.pdf',
              name: 'loan',
              date: '12.06.2025'
            },
            {
              path: '/static/documents/archive/loan/30_04_2025.pdf',
              name: 'loan',
              date: '30.04.2025'
            },
            {
              path: '/static/documents/archive/loan/31_10_2024.pdf',
              name: 'loan',
              date: '31.10.2024'
            },
            {
              path: '/static/documents/archive/loan/21_03_2024.pdf',
              name: 'loan',
              date: '21.03.2024'
            },
            {
              path: '/static/documents/archive/loan/07_11_2023.pdf',
              name: 'loan',
              date: '07.11.2023'
            }
          ]
        },
        {
          name: 'scoring',
          items: [
            {
              path: '/static/documents/archive/scoring/03_03_2026.pdf',
              name: 'scoring',
              date: '03.03.2026'
            },
            {
              path: '/static/documents/archive/scoring/28_08_2025.pdf',
              name: 'scoring',
              date: '28.08.2025'
            }
          ]
        },
        {
          name: 'offer',
          items: [
            {
              path: '/static/documents/archive/offer/28_02_2026.docx',
              name: 'offer',
              date: '28.02.2026'
            },
            {
              path: '/static/documents/archive/offer/27_02_2026.pdf',
              name: 'offer',
              date: '27.02.2026'
            },
            {
              path: '/static/documents/archive/offer/26_02_2026.pdf',
              name: 'offer',
              date: '26.02.2026'
            },
            {
              path: '/static/documents/archive/offer/10_04_2024.pdf',
              name: 'offer',
              date: '10.04.2024'
            },
            {
              path: '/static/documents/archive/offer/03_04_2024.pdf',
              name: 'offer',
              date: '03.04.2024'
            }
          ]
        },
        {
          name: 'policy',
          items: [
            {
              path: '/static/documents/archive/policy/14_06_2026.pdf',
              name: 'policy',
              date: '14.06.2026'
            },
            {
              path: '/static/documents/archive/policy/29_12_2025.pdf',
              name: 'policy',
              date: '29.12.2025'
            },
            {
              path: '/static/documents/archive/policy/23_02_2025.pdf',
              name: 'policy',
              date: '23.02.2025'
            },
            {
              path: '/static/documents/archive/policy/26_02_2024.pdf',
              name: 'policy',
              date: '26.02.2024'
            }
          ]
        }
      ]
    };
  },
  methods: {
    toggleSection(sectionIndex) {
      this.$set(this.openSections, sectionIndex, !this.openSections[sectionIndex]);
    },
  }
};
</script>

<style lang="scss" scoped>
.documents-page-wrapper {
  @include base-page-wrapper;
  @include static-heading-container;

  min-height: auto;
}

.documents-scroll {
  width: 100%;
  overflow-x: auto;
}

.documents-data {
  width: 95%;
  min-width: 770px;
  max-width: 1730px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.documents-heading {
  @include document-heading;
}

.heading-items-block {
  display: flex;
  height: 100%;
  align-items: center;
  gap: 15px;
}

.documents-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: stretch;
}

.document-item-title {
  @include document-item;
  justify-content: flex-start;
  cursor: pointer;
  user-select: none;

  .item-link {
    &:hover {
      text-decoration: none;
    }
  }

  .item-desc {
    color: black;
  }
}

.item-arrow {
  transform: rotate(180deg);
  margin-right: 18px;
  transition: transform .25s ease;
}

.item-arrow-open {
  transform: rotate(0deg);
}

.documents-items {
  overflow: hidden;
  max-height: 0;
  transition: max-height .3s ease;
  width: 100%;
}

.documents-items-open {
  max-height: 380px;
  overflow: auto;
}

.document-item {
  @include document-item;

  background-color: #fff;
  padding: 20px 10px 20px 55px;

  &:not(:last-of-type) {
    border-bottom: 1px solid #eceef0;
  }
}

.item-link {
  all: unset;
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.item-desc {
  font-size: .895rem;
  color: #1a8d48;
  font-weight: 600;
}

.item-date {
  color: #01273b;
}

.pl-20 {
  padding-left: 20px;
}

</style>